export const RiskBubbleChartSettingsTestIds = {
  BubbleSize: 'bubbleSize',
} as const;
